module.exports = __webpack_public_path__ + "static/media/proj19_img9.10dd23af.jpg";